import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
import { LicenseManager, AllEnterpriseModule } from 'ag-grid-enterprise';
import assortmentStripedGridTheme from './ag-grid-striped-theme';

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

// Provide a global default settings to all Grids. Individual grids can still override those.
const defaultGridOptions = {
  theme: assortmentStripedGridTheme,
  // adds overall counter to all grids on footer
  statusBar: {
    statusPanels: [
      { statusPanel: 'agTotalAndFilteredRowCountComponent' },
      { statusPanel: 'agTotalRowCountComponent' },
      { statusPanel: 'agFilteredRowCountComponent' },
      { statusPanel: 'agSelectedRowCountComponent' },
      { statusPanel: 'agAggregationComponent' },
    ],
  },
  // Enables default text filter
  defaultColDef: { filter: true },
};
provideGlobalGridOptions(defaultGridOptions);

// Set ag-grid license
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-054150}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Wyman_Oliver_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{6}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{14}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{24_February_2025}____[v3]_[01]_MTc0MDM1NTIwMDAwMA==e41778debb5bf8aae8a4f23395613f6c'
);
